var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMkr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.338 23.388V11.314l9.156 6.891v5.183h2.338V17.72a1.365 1.365 0 0 0-.544-1.089L3.184 8.275A1.364 1.364 0 0 0 1 9.362v14.026h2.338zm25.324 0V11.314l-9.156 6.891v5.183h-2.338V17.72c0-.428.2-.832.543-1.089l11.106-8.356A1.364 1.364 0 0 1 31 9.364v14.025h-2.338v-.002z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMkr);
export default __webpack_public_path__ + "static/media/MKR.db6e052e2c088598b7b89706d963b4dd.svg";
export { ForwardRef as ReactComponent };